import { faPen } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaterialTable from "material-table";
import React, { useCallback, useEffect, useState } from "react";
import { getDepartments } from "../../api/department";
import { tableIcons } from "../../helpers/tableIcons";
import local from "../../localization/strings";
import Loader from "../common/Loader";
import { Modal, ModalBody } from "reactstrap";
import UserManagementAreaEdit from "./user-management-area-edit";
import AddButton from "../common/AddButton";

const UserManagementAreas = () => {
	const [loading, setLoading] = useState(true);
	const [items, setItems] = useState([]);
	const [editId, setEditId] = useState(undefined);

	const LoadData = useCallback(async () => {
		setEditId(undefined);
		setLoading(true);
		const result = await getDepartments();

		setItems(result);
		setLoading(false);
	}, []);

	useEffect(() => {
		LoadData();
	}, [LoadData]);

	const columns = [
		{
			render: (rowData) => (
				<FontAwesomeIcon
					icon={faPen}
					className="cursor-pointer"
					onClick={() => {
						setEditId(rowData.id);
					}}
				/>
			),
		},
		{ field: "name", title: local.TS_Name }, //
	];

	return (
		<>
			{editId && (
				<Modal isOpen={!!editId} toggle={() => setEditId(undefined)} centered backdrop="static">
					<ModalBody>
						<UserManagementAreaEdit departments={items} editId={editId} onDone={LoadData} />
					</ModalBody>
				</Modal>
			)}
			{loading && <Loader />}
			{!loading && (
				<>
					<div className="text-right mb-2">
						<AddButton string={local.TS_Add} clickFunction={() => setEditId(-1)} />
					</div>
					<div className="MuiTable-SmallHeader MuiTable-NoShadow">
						<MaterialTable columns={columns} data={items} title="" icons={tableIcons} options={{ sorting: true, paging: true, pageSize: 50, pageSizeOptions: [50], emptyRowsWhenPaging: false, search: false, showEmptyDataSourceMessage: false, headerStyle: { backgroundColor: "#edf2f9", color: "#01579b" } }} />
					</div>
				</>
			)}
		</>
	);
};

export default UserManagementAreas;
